import React from 'react';
import {connect} from 'react-redux';

import MainLayout      from 'app/components/layout/main-layout';
import AccountSlx from 'app/selectors/account';
import ClientTimestamp from 'app/components/common/client-timestamp';

class PageAccountSessions extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  renderTable() {
    const {sessions} = this.props;
    if (!sessions) return 'loading...';

    return (
      <table className="default">
        <thead>
          <tr>
            <th></th>
            <th>Created</th>
            <th>Expired</th>
            <th>Location</th>
            <th>Device</th>
          </tr>
        </thead>
        <tbody>
          {sessions.map((session) => {
            return (
              <tr key={sessions.id}>
                <td>
                  {session.isValid
                    ? <span className="chip small green">Active</span>
                    : <span className="chip small">Expired</span>
                  }
                </td>
                <td><ClientTimestamp timestamp={session.createdTs} format="MMM D, YYYY hh:mm:ssA" showTz /></td>
                <td>{!!session.expiredTs && <ClientTimestamp timestamp={session.expiredTs} format="MMM D, YYYY hh:mm:ssA" showTz />}</td>
                <td>{session.location}</td>
                <td>{session.device}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      );
  }

  render() {
    return (
      <MainLayout>
        <div className="widther">
          <h1>Sessions</h1>
          {this.renderTable()}
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </MainLayout>
    );
  }

}

const stateToProps = (state) => ({
  sessions: AccountSlx.sessions(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageAccountSessions);
